import { FC, MouseEventHandler } from "react";

import LoadingButton from "@mui/lab/LoadingButton";

import { SxProps, Theme } from "@mui/material";
import classes from "./Button.module.css";

interface SolarGikButtonProps {
  icon?: React.ReactNode;
  text?: string;
  style: SxProps<Theme>;
  onClickFunc?: MouseEventHandler<HTMLButtonElement>;
  isDisabled?: boolean;
  isLoading?: boolean;
  type?: "button" | "submit" | "reset";
  rootClassName?: string;
}
//This is the button component for the app
//Do not override its css! use the style prop instead
const SolarGikButton: FC<SolarGikButtonProps> = ({
  icon,
  text,
  style,
  onClickFunc,
  isDisabled,
  isLoading = false,
  type,
  rootClassName,
}) => {
  return (
    <LoadingButton
      className={classes["rounded-button"]}
      sx={style}
      onClick={onClickFunc}
      endIcon={icon}
      disabled={isDisabled}
      loading={isLoading}
      type={type}
      classes={{ root: rootClassName }}
    >
      <span className={classes.label}>{text}</span>
    </LoadingButton>
  );
};
export default SolarGikButton;
